<div class="produto-img" [style.height.px]="height" style="overflow: clip">
  <div
    *ngIf="quantity"
    class="product-quantity-box"
    [style.backgroundColor]="site.backgroundColorSliderSuperior"
  >
    <div class="product-quantity">
      <span>{{ quantity }}</span>
    </div>
  </div>
  <a (click)="redirectTo.emit(product.id)">
    <div *ngIf="product.imagem; else elseBlockImg">
      <div *ngIf="product.imagem2; else elseBlockImg2">
        <img
          src="{{ API_IMAGENS_PRODUTOS }}{{ product.imagem2 }}"
          [style.max-height.px]="height"
          class="bottom img-fluid"
          [height]="height"
        />
        <img
          src="{{ API_IMAGENS_PRODUTOS }}{{ product.imagem }}"
          [style.max-height.px]="height"
          class="top img-fluid"
          [height]="height"
        />
        <div *ngIf="product.observacao && (product.observacao !== null || product.observacao !== '')" class="pre-venda-tag">
          <span class='ml-5 mr-5'>
            {{ product.observacao }}
          </span>
        </div>
      </div>
      <ng-template #elseBlockImg2>
        <img
          src="{{ API_IMAGENS_PRODUTOS }}{{ product.imagem }}"
          [style.max-height.px]="height"
          class="img-fluid"
          [height]="height"
        />
        <div *ngIf="product.observacao && (product.observacao !== null || product.observacao !== '')" class="pre-venda-tag">
          <span class='ml-5 mr-5'>
            {{product.observacao}}
          </span>
        </div>
      </ng-template>
    </div>
    <ng-template #elseBlockImg>
      <img
        src="assets/no-product-image.jpg"
        [style.max-height.px]="height"
        class="img-fluid"
        [height]="height"
      />
      <div *ngIf="product.observacao && (product.observacao !== null || product.observacao !== '')" class="pre-venda-tag">
        <span class='ml-5 mr-5'>
          {{ product.observacao }}
        </span>
      </div>
    </ng-template>
  </a>
  <div
    *ngIf="rebate"
    class="product-promotion desconto-anuncio"
    [style.backgroundColor]="site.backgroundColorSliderSuperior"
  >
    <p class="vertical-center">{{ rebate }}% OFF</p>
  </div>
   <div
    class="estoque-flag"
    *ngIf="showStock"
    [style.backgroundColor]="site.backgroundColorSliderSuperior"
  >
    <p *ngIf="this.product.estoque >= 0; else estoqueIndisponivel" class="vertical-center">Estoque: {{stock}}</p>
    
    <ng-template #estoqueIndisponivel>
      
      <p class="vertical-center" i18n>Indisponível</p>
    </ng-template>
  </div>
  
</div>
